import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="card p-6">
        <h1 className="text-3xl font-bold mb-4">Shipping Policy</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          This Shipping Policy explains how TRENDZ processes and ships orders.
        </p>

        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-2">Order Processing</h2>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1">
              <li>Orders are typically processed within 1–2 business days.</li>
              <li>During sales or peak periods, processing may take slightly longer.</li>
              <li>We do not process orders on public holidays.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Delivery Time</h2>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1">
              <li>Standard Delivery: 3–5 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Shipping Charges</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Shipping charges (if any) are shown at checkout before you place your order.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Delivery Areas</h2>
            <p className="text-gray-600 dark:text-gray-400">
              We deliver to most cities in Pakistan. If your area is not serviceable, our team
              will contact you.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Address Accuracy</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Please ensure your address and phone number are correct at checkout. Delays due to
              incorrect details are not the responsibility of TRENDZ.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;

